<script lang="ts">
  import { onMount } from "svelte";
  import { get } from "svelte/store";
  import { widgetState } from "./store/widget.store";
  import { emitHeightAdjustEvent } from "./service/common.service";
  import Placeholder from "./components/Placeholder.svelte";
  import RankingList from "./components/RankingList.svelte";

  let pageWidth = "auto";
  let pageHeight = "auto";
  let backgroundColor = 'F9FAFB';

  const params = new URLSearchParams(window.location.search);
  if (Boolean(params.get("width"))) {
    pageWidth = params.get("width");
  }

  if (Boolean(params.get("height"))) {
    pageHeight = params.get("height");
  }

  onMount(async () => {
    await widgetState.loadWidget();
    const state = get(widgetState);
    if (!state.isError) {
      setTimeout(emitHeightAdjustEvent, 1000);
	  backgroundColor = state.config.background_color;
    }
  });
</script>

{#if $widgetState.isError === false}
  <main
    class="bg-gray-50 h-full"
    style="max-width: {pageWidth}; max-height:{pageHeight}"
  >
    <div class="p-2 mx-auto" style="background-color: #{backgroundColor}">
      {#if $widgetState.isLoading === false}
        <RankingList />
      {:else}
        <Placeholder />
      {/if}
    </div>
  </main>
{/if}

<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
</style>
